.backdrop {
  position: fixed;
  inset: 0;
  z-index: 100;
  background: var(--color-overlay);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-4);
  animation: fade 150ms ease;
}
.modal {
  /* Visible edge against the dimmed page, especially in the dark theme. */
  border: 1.5px solid color-mix(in srgb, var(--color-primary) 60%, var(--color-border));
  width: 100%;
  max-width: 440px;
  max-height: calc(100vh - 48px);
  overflow: auto;
  background: var(--color-surface);
  border-radius: var(--radius-lg);
  padding: var(--space-6);
  box-shadow: var(--shadow-lg);
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}
.sheetBackdrop {
  align-items: flex-end;
  padding: 0;
}
.sheet {
  /* Visible edge against the dimmed page, especially in the dark theme. */
  border: 1.5px solid color-mix(in srgb, var(--color-primary) 60%, var(--color-border));
  width: 100%;
  max-width: 560px;
  max-height: 88vh;
  overflow: auto;
  background: var(--color-surface);
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  padding: var(--space-3) var(--space-5) calc(var(--space-6) + var(--safe-bottom));
  box-shadow: var(--shadow-lg);
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  animation: slideUp 200ms ease;
}
.handle {
  width: 40px;
  height: 4px;
  border-radius: 2px;
  background: var(--color-border);
  align-self: center;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
}
.actions {
  position: sticky;
  bottom: calc(-1 * var(--space-6) - var(--safe-bottom));
  margin: 0 calc(-1 * var(--space-5));
  padding: var(--space-3) var(--space-5) calc(var(--space-3) + var(--safe-bottom));
  background: var(--color-surface);
  border-top: 1px solid var(--color-border);
  display: flex;
  gap: var(--space-2);
  justify-content: flex-end;
  flex-wrap: wrap;
}
/* a centred dialog has no screen edge under it: no sticky footer, no safe-area gap */
.modal > .actions {
  position: static;
  margin: 0;
  padding: var(--space-3) 0 0;
}
@media (min-width: 768px) {
  .sheetBackdrop {
    align-items: center;
    padding: var(--space-4);
  }
  .sheet {
    border-radius: var(--radius-lg);
  }
}
/* Messages like «Мітку переміщено…» appear at the top, so they never cover buttons, the chat input or the menu. */
.toasts {
  position: fixed;
  left: 50%;
  top: calc(var(--space-3) + env(safe-area-inset-top, 0px));
  transform: translateX(-50%);
  z-index: 200;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  width: min(92vw, 420px);
  pointer-events: none;
}
.toast {
  pointer-events: auto;
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-md);
  background: var(--color-text);
  color: var(--color-bg);
  box-shadow: var(--shadow-md);
  animation: slideDown 200ms ease;
  display: flex;
  justify-content: space-between;
  gap: var(--space-3);
}
.toast-error {
  background: var(--color-danger);
  color: #fff;
}
.toast-success {
  background: var(--color-help);
  color: #fff;
}
.toastClose {
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
}
@keyframes fade {
  from {
    opacity: 0;
  }
}
@keyframes slideUp {
  from {
    transform: translateY(16px);
    opacity: 0;
  }
}
@media (min-width: 1024px) {
  .toasts {
    top: var(--space-5);
  }
}

.lightbox {
  position: fixed;
  inset: 0;
  z-index: 200;
  display: grid;
  grid-template: minmax(0, 1fr) / minmax(0, 1fr);
  place-items: center;
  padding: calc(56px + env(safe-area-inset-top, 0px)) var(--space-3) calc(var(--space-6) + var(--safe-bottom));
  background: rgb(8 14 13 / 0.94);
}
.lightboxImage {
  /* fits the screen whatever the photo's size: the grid cell is bounded, and dvh is a fallback */
  max-width: 100%;
  max-height: 100%;
  max-height: min(
    100%,
    calc(100dvh - 56px - var(--space-6) - env(safe-area-inset-top, 0px) - var(--safe-bottom))
  );
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: var(--radius-sm);
}
.lightboxClose,
.lightboxNav {
  position: absolute;
  display: grid;
  place-items: center;
  width: 48px;
  height: 48px;
  border: 0;
  border-radius: 50%;
  background: rgb(255 255 255 / 0.16);
  color: #fff;
  font-size: 22px;
  cursor: pointer;
}
.lightboxClose {
  top: calc(var(--space-3) + env(safe-area-inset-top, 0px));
  right: var(--space-3);
}
.lightboxNav {
  top: 50%;
  transform: translateY(-50%);
  font-size: 32px;
}
.lightboxPrev {
  left: var(--space-3);
}
.lightboxNext {
  right: var(--space-3);
}
.lightboxClose:hover,
.lightboxNav:hover {
  background: rgb(255 255 255 / 0.28);
}
.lightboxClose:focus-visible,
.lightboxNav:focus-visible {
  outline: 2px solid #fff;
}
.lightboxCount {
  position: absolute;
  bottom: calc(var(--space-3) + var(--safe-bottom));
  color: rgb(255 255 255 / 0.8);
  font-size: var(--text-sm);
  font-weight: 700;
}
@keyframes slideDown {
  from {
    transform: translateY(-16px);
    opacity: 0;
  }
}
